import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from './../../../../../../Assets/icons/backIcon.svg';
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import { ToastContainer } from "react-toastify";
import Swal from 'sweetalert2';


const EditRTO = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ rtoData, setRtoData ] = useState([])

  const [ stateVal, setStateVal  ] = useState([])
  const [ cityIdVal, setCityIdVal ] = useState([])

  const [ cityValueData, setCityValueData  ] = useState([])

  const navigate = useNavigate();

  const token = localStorage.getItem("authToken");

  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    fetchStateList()
  },[])

  const fetchStateList = async () => {
    try{
      const response = await axiosInstance.get("/pincodestatecity/stateList",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response?.data?.data
      console.log(data, "stateOptions")
      const stateOptions = data?.map(state => ({
        value: state.state_id,
        label:state.state_name,
      }))
      setStateVal(stateOptions)
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    
    if(formData.stateid){
      console.log(formData.stateid, "StateIdVAL")
      const stateId = formData.stateid
      setCityIdVal(stateId)
      fetchCityList()
    }
  },[formData.stateid])

  const fetchCityList = async () => {
    try{
      const response = await axiosInstance.get(`pincodestatecity/cityList/${formData.stateid}`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response?.data?.data
      console.log(data, "stateOptions")
      const stateOptions = data?.map(state => ({
        value: state.city_id,
        label:state.city_name,
      }))
      setCityValueData(stateOptions)
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    fetchRtoEdit();
  },[])

  const fetchRtoEdit = async () => {
    try{
      const response = await axiosInstance.get(`/rto/edit/${data.rto_id}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })
    const formatData = response.data.data;
    const transformedData = {
      rtocode:formatData.rtocode,
      rtolabel:formatData.rtolabel,
      groupcode:formatData.groupcode,
      rtocity:formatData.rtocity,
      cityid:formatData.cityid,
      stateid:formatData.stateid,
      status: formatData.status === 1 ? "Active" : "Inactive",
      business_partner_id:formatData.business_partner_id,
    }
    setFormData(transformedData)
    // setDEpartment(formatData)
    setRtoData(formatData)
    console.log(formData, "depatartment DATA")
  
  }catch(error){
      console.log(error)
    }
  
  }


  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validation logic for required fields
    RTOInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
  
    // If validation fails, display validation errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    setIsLoading(true);
    console.log("formData", formData);
  
    try {
      // Sending the patch request to update the RTO
      const response = await axiosInstance.patch(
        `/rto/update/${data.rto_id}`,
        {
          rtocode: formData.rtocode,
          rtolabel: formData.rtolabel,
          groupcode: formData.groupcode,
          rtocity: formData.rtocity,
          cityid: formData.cityid,
          stateid: formData.stateid,
          zonetypeid: 1,
          commercialzonetypeid: 1,
          isncr: 0,
          status: formData.status === "Active" ? 1 : 0,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log("Unit added successfully:", response.data);
  
      // Success Alert
      Swal.fire({
        title: "Success",
        text: "RTO updated successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });
  
      navigate('/admin/manage-dealer/rto'); 
    } catch (error) {
      console.error('Error updating RTO:', error);
  
      // Error Alert
      Swal.fire({
        title: "Error",
        text: "Failed to update RTO. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsLoading(false);
    }
  };
  

  const RTOInputs = [
    {
      name: "rtocode",
      label: "RTO Code",
      placeholder:"Enter RTO Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[A-Za-z0-9 ]*$/,
        message: "Only alphabets and digits are allowed",
       },
    },
    {
      name: "rtolabel",
      label: "RTO Label",
      placeholder:"Enter RTO Label",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "groupcode",
      label: "Group Code",
      placeholder:"Enter Group Code",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "rtocity",
      label: "RTO City",
      type: "text",
      placeholder:"Enter RTO City",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "stateid",
      label: "State Id",
      type: "dropdown",
      options: stateVal ,
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "cityid",
      label: "City Id",
      type: "dropdown",
      required: true,
      options:cityValueData  ,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    // {
    //   name: "zonetypeid",
    //   label: "ZoneType Id",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "commercialzonetypeid",
    //   label: "Commercial Zone Type Id",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    // {
    //   name: "isncr",
    //   label: "ISNCR",
    //   type: "number",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
    <ToastContainer />
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Add New RTO</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Enter RTO Details
        </span>
        <DynamicForm
          formConfig={RTOInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default EditRTO;
